module.exports = __webpack_public_path__ + "static/media/master.a1b5fe0c.png";